import { all, call, delay, put } from "redux-saga/effects";
import { removeAuthToken, setAuthToken } from "../../utils/storage/storage";
import { userAuthCurrent, userAuthLoginGoogle } from "./api";
import * as TYPES from "./type";
import * as MENU_TYPES from "../menu/type";
import * as CHANGE_TYPES from "../changDevice/type"

export function* userAuthCurrentAction({ payload }: any): any {
  try {
    if (payload?.callCheck) {
      return;
    }
    const res = yield call(userAuthCurrent);
    const { menu, user, data } = res;
    const filterChangeData = data.filter((e: any) => e.maintainChangeStatus === "STCH-001")
    yield all([
      put({
        type: TYPES.AUTH_CURRENT_SUCCESS,
        payload: user,
      }),
      put({
        type: MENU_TYPES.MENU_SUCCESS,
        payload: menu,
      }),
      put({
        type: CHANGE_TYPES.CHANGE_DEVICE_CURRENT_SUCCESS,
        payload: filterChangeData,
      }),
    ]);
  } catch (error: any) {
    const responseError = error?.response?.data?.error;
    const responseStatus = error?.response?.status || 400;
    yield all([
      put({
        type: TYPES.AUTH_CURRENT_FAIL,
        payload: {
          message: responseError,
          status: responseStatus,
        },
      }),
    ]);
  }
}

export function* userLoginGoogleAction({ payload }: any): any {
  try {
    const { auth } = payload;
    // ### CALL API LOGIN ###
    const res = yield call(userAuthLoginGoogle, { auth });
    const {
      result: { accessToken },
    } = res;
    setAuthToken({ accessToken });
    const res2 = yield call(userAuthCurrent);
    const { menu, user } = res2;
    yield all([
      put({
        type: TYPES.AUTH_LOGIN_GOOGLE_SUCCESS,
        payload: user,
      }),
      put({
        type: MENU_TYPES.MENU_SUCCESS,
        payload: menu,
      }),
    ]);
  } catch (error: any) {
    console.log(error);
    const responseError = error?.response?.data?.error;
    const responseStatus = error?.response?.status || 400;
    yield all([
      put({
        type: TYPES.AUTH_LOGIN_GOOGLE_FAIL,
        payload: {
          message: responseError,
          status: responseStatus,
        },
      }),
    ]);
  }
}

export function* userLogoutGoogleAction(): any {
  try {
    removeAuthToken();
    yield all([
      put({
        type: TYPES.AUTH_LOGOUT_GOOGLE_SUCCESS,
      }),
    ]);
  } catch (error: any) {
    console.log(error);
    const responseError = error?.response?.data?.error;
    const responseStatus = error?.response?.status || 400;
    yield all([
      put({
        type: TYPES.AUTH_LOGIN_GOOGLE_FAIL,
        payload: {
          message: responseError,
          status: responseStatus,
        },
      }),
    ]);
  }
}
